import axios from 'axios'

export function fetchPermissions () {
  return axios.get('/permissions')
}
